export default class Feature {
  constructor() {
    this.example = 'example';
  }

  init() {
    this.example = 'initialized';
  }
}



// WEBPACK FOOTER //
// /Users/michaelwheeler/Desktop/code/cmp_workspace/campaigns/macys-new-stores/src/macys-new-stores.js